async function removeItemsByRefId(event, refId) {
  event.preventDefault();
  if (!refId) return;

  try {
    // current cart
    const cart = await fetch(`${Shopify.routes.root}cart.js`).then(r => r.json());

    // updates object
    const updates = {};
    cart.items.forEach(item => {
      const itemRefId = item.properties?._refId;
      if (itemRefId && String(itemRefId) === String(refId)) {
        updates[item.key] = 0;
      }
    });


    if (Object.keys(updates).length === 0) return;

    // send update
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates })
    });

    const updatedCart = await response.json();

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: { cart: updatedCart }
      })
    );

  } catch (err) {
    console.error("Failed to remove items by refId:", err);
  }
}